import { MdOutlineSettings, MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import { Button } from '@ds';

type SettingsButtonsProps = {
  isDataLoading: boolean;
  showSettings: boolean;
  showBenchmark: boolean;
  hasBenchmark: boolean;
  setShowSettings: (show: boolean) => void;
  setShowBenchmark: (show: boolean) => void;
};

export const SettingsButtons = ({
  isDataLoading,
  showSettings,
  showBenchmark,
  hasBenchmark,
  setShowSettings,
  setShowBenchmark,
}: SettingsButtonsProps) => {
  const benchmarkSettingIcon = showBenchmark ? <MdOutlineVisibilityOff size={18} /> : <MdOutlineVisibility size={18} />;
  const benchmarkSettingTitle = showBenchmark ? 'Hide Benchmark' : 'Show Benchmark';

  return (
    <div className="flex items-center gap-2">
      <Button
        size="sm"
        variant="light"
        isDisabled={isDataLoading}
        startContent={<MdOutlineSettings size={18} />}
        onPress={() => setShowSettings(!showSettings)}
      >
        Settings
      </Button>
      <Button
        size="sm"
        variant="light"
        startContent={benchmarkSettingIcon}
        isDisabled={!hasBenchmark}
        onPress={() => setShowBenchmark(!showBenchmark)}
      >
        {benchmarkSettingTitle}
      </Button>
    </div>
  );
};
